<template>
  <div>
    <v-tabs
      v-model="tab"
      class="p-custom-content-tabs"
    >
      <v-tab
        v-for="channel in post.channels"
        :key="channel.channelId"
        :set="socialMediaChannel = socialMediaChannelById(channel.channelId)"
      >
        <p-social-media-icon
          :id="socialMediaChannel.socialMediaId"
          left
        ></p-social-media-icon>
        {{ socialMediaChannel.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="channel in post.channels"
        :key="channel.channelId"
      >
        <v-card
          :color="channel.customPostContentEnabled ? '' : 'grey lighten-5'"
          flat
        >
          <v-card-text>
            <v-checkbox
              :input-value="channel.customPostContentEnabled"
              :label="$t('socialMediaPost.edit.useCustomContent')"
              class="mt-0"
              @change="(checked) => onCustomPostContentCheckboxChange(checked, channel)"
            ></v-checkbox>

            <wordpress-custom-content
              :ref="`wordpressCustomContent${channel.channelId}`"
              v-if="channel.socialMediaId === socialMedia.wordPress"
              :channel-id="channel.channelId"
              :custom-content.sync="channel.customPostContent"
              :custom-content-enabled="channel.customPostContentEnabled"
              :default-content="post"
            ></wordpress-custom-content>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

import { socialMedia } from '@/constants'

import PSocialMediaIcon from '@/components/PSocialMediaIcon'
import WordpressCustomContent from './WordPressCustomContent'

import objectMixin from '@/mixins/object.mixin'


export default {
  components: {
    PSocialMediaIcon,
    WordpressCustomContent
  },


  mixins: [
    objectMixin
  ],


  props: {
    post: {
      type: Object
    }
  },


  data () {
    return {
      socialMedia,
      tab: 0
    }
  },


  computed: {
    ...mapGetters('socialMediaChannel', ['socialMediaChannelById'])
  },


  methods: {
    onCustomPostContentCheckboxChange (checked, channel) {
      channel.customPostContentEnabled = !!checked
      if (checked && !channel.customPostContent) {
        channel.customPostContent = {
          title: this.post.title,
          message: this.post.message,
          embedMedia: this.post.embedMedia,
          includeEvents: this.post.includeEvents,
          featured: this.post.featured,
          images: [],
          scheduledPublishTimeUtc: this.post.scheduledPublishTimeUtc,
          unPublishTimeUtc: this.post.unPublishTimeUtc
        }

        for (const image of this.post.images) {
          if (image.id) {
            const preparedImage = {}
            preparedImage.id = image.id
            preparedImage.title = image.title
            preparedImage.text = image.text
            preparedImage.previewUrl = image.previewUrl
            channel.customPostContent.images.push(preparedImage)
          } else {
            const newFile = new File([image], image.name, { type: image.type })
            channel.customPostContent.images.push(newFile)
          }
        }
      }
    }
  }
}
</script>
